// Специальности фармработников
export const pharmacySpecialties = [
  { value: 'pharmacist', label: 'Фармацевт' },
  { value: 'pharmacy', label: 'Провизор' },
  { value: 'pharmacy_management', label: 'Управление и экономика фармации' },
  {
    value: 'pharmaceutical_chemistry',
    label: 'Фармацевтическая химия и фармакогнозия',
  },
  { value: 'pharmaceutical_technology', label: 'Фармацевтическая технология' },
  { value: 'other', label: 'Другая специальность' },
]
